import { Link } from "react-router-dom";
import { Landmark } from "lucide-react";
import { money } from "@/lib/odds";

export function RealAccountPanel({ real, modelProfit }) {
  if (!real) return null;
  const pl = (n) => <span className={n >= 0 ? "text-emerald-400" : "text-red-400"}>{n >= 0 ? "+" : ""}{money(n)}</span>;
  return (
    <section className="glass-card p-6" data-testid="real-account-panel">
      <div className="flex flex-wrap items-center gap-3">
        <h2 className="font-display flex items-center gap-2 text-2xl font-bold uppercase tracking-tight text-white"><Landmark size={18} className="text-cyan-400" /> Real account</h2>
        <p className="text-xs text-slate-400">Your logged stakes and book odds — so P/L here matches what's actually in your sportsbook.</p>
        <Link to="/parlays" data-testid="real-account-log-link" className="ml-auto text-xs font-semibold uppercase tracking-wider text-cyan-400 hover:underline">Log bets on My Parlays →</Link>
      </div>
      {real.placed === 0 ? (
        <p className="mt-4 text-sm text-slate-500" data-testid="real-account-empty">No real bets logged yet. Open any saved parlay and hit <b>Log real bet</b> to record the book, stake and odds you actually got.</p>
      ) : (
        <>
          <div className="mt-4 grid gap-3 sm:grid-cols-4">
            {[["Real P/L", pl(real.profit), "real-profit"], ["Real ROI", <span className={real.roi >= 0 ? "text-emerald-400" : "text-red-400"}>{real.roi >= 0 ? "+" : ""}{real.roi}%</span>, "real-roi"], ["Staked (settled)", money(real.stake), "real-stake"], ["Open stake", money(real.open_stake), "real-open"]].map(([l, v, id]) => (
              <div key={id} className="rounded-lg border border-[#26334D] bg-[#121824] px-4 py-3"><p className="text-[10px] uppercase tracking-wider text-slate-500">{l}</p><p data-testid={id} className="font-mono-num mt-1 text-xl font-bold text-white">{v}</p></div>
            ))}
          </div>
          <p className="mt-3 text-xs text-slate-400" data-testid="real-vs-model">Model $ on the same {real.settled} settled ticket{real.settled !== 1 ? "s" : ""}: {pl(real.model_profit_same_tickets)} · your real result: {pl(real.profit)} <span className="text-slate-600">({real.placed} logged, {real.pending} still live)</span></p>
          <ul className="mt-4 divide-y divide-[#26334D]/60 rounded-lg border border-[#26334D] bg-[#0B0E14]/60" data-testid="real-by-book">
            {real.by_book.map((b) => (
              <li key={b.book} data-testid="real-book-row" className="flex items-center gap-3 px-4 py-2 text-sm">
                <span className="flex-1 font-semibold text-white">{b.book}</span>
                <span className="font-mono-num text-xs text-slate-500">{b.n} bet{b.n !== 1 ? "s" : ""}{b.pending ? ` · ${b.pending} live` : ""}</span>
                <span className="font-mono-num text-xs text-slate-400">{money(b.stake)} staked</span>
                <span className="font-mono-num w-24 text-right font-bold">{pl(b.profit)}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
